<template>
    <div>
        <!-- tabs -->
        <v-tabs v-model="tab" show-arrows height="25">
            <v-tab
                class="text-capitalize "
                :to="{ 
                    name: 'material-simulation-cardamom'
                }"
            >
				{{ $T('TabSimulationMaterial.raw-cardamom') }}
            </v-tab>

            <v-tab
                class="text-capitalize "
                :to="{ 
                    name: 'material-simulation'
                }"
            >
				{{ $T('TabSimulationMaterial.material') }}
            </v-tab>

            <v-tabs-slider color="primary"></v-tabs-slider>
        </v-tabs>
        <v-divider class="mb-2"/>

         <!-- child page -->
        <loader v-if="loading"/>
        <router-view v-else/>
    </div>
</template>
<script>
export default {
	data() {
		return {
			tab: 0,
			loading: false
		}
	}
}
</script>
